module.exports = __webpack_public_path__ + "static/media/ic_social_twitter_filled.dfa6da24.svg";